import React from 'react';
import { Clock, TrendingUp } from 'lucide-react';

function AverageDeliveryTime({ data }) {
  if (!data) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
        <Clock className="w-12 h-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500 font-montserrat">No hay datos de tiempo de entrega</p>
      </div>
    );
  }

  const { 
    overall_avg_hours = 0, 
    by_seller = [], 
    same_day_rate = 0,
    same_day_count = 0,
    total_delivered = 0
  } = data;

  return (
    <div className="space-y-6">
      {/* Overall Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-gradient-to-r from-[#B1336E]/10 to-[#E6B43C]/10 rounded-xl p-6 border-l-4 border-[#B1336E]">
          <div className="flex items-center gap-3 mb-2">
            <Clock className="w-8 h-8 text-[#B1336E]" />
            <div>
              <p className="text-xs text-slate-600 font-montserrat">Tiempo Promedio</p>
              <p className="text-3xl font-bold text-[#B1336E] font-montserrat">
                {overall_avg_hours.toFixed(1)} hrs
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#67A43C]/10 to-[#67A43C]/5 rounded-xl p-6 border-l-4 border-[#67A43C]">
          <div className="flex items-center gap-3 mb-2">
            <TrendingUp className="w-8 h-8 text-[#67A43C]" />
            <div>
              <p className="text-xs text-slate-600 font-montserrat">Tasa Mismo Día</p>
              <p className="text-3xl font-bold text-[#67A43C] font-montserrat">
                {same_day_rate}%
              </p>
            </div>
          </div>
        </div>

        <div className="bg-slate-50 rounded-xl p-6 border-l-4 border-slate-300">
          <div>
            <p className="text-xs text-slate-600 font-montserrat mb-1">Entregas Mismo Día</p>
            <p className="text-2xl font-bold text-slate-900 font-montserrat">
              {same_day_count} / {total_delivered}
            </p>
          </div>
        </div>
      </div>

      {/* By Seller */}
      {by_seller.length > 0 && (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="bg-slate-50 border-b border-slate-200 px-4 py-3">
            <h3 className="text-sm font-bold text-slate-900 font-montserrat">
              Tiempo Promedio por Vendedor
            </h3>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600 font-montserrat">
                    Vendedor
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">
                    Entregas
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">
                    Tiempo Promedio
                  </th>
                  <th className="px-4 py-3 text-right text-xs font-semibold text-slate-600 font-montserrat">
                    Estado
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {by_seller.map((seller, index) => (
                  <tr key={index} className="hover:bg-slate-50 transition-colors">
                    <td className="px-4 py-3">
                      <p className="text-sm font-semibold text-slate-900 font-montserrat">
                        {seller.seller}
                      </p>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className="text-sm text-slate-600 font-montserrat">
                        {seller.delivery_count}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className="text-sm font-bold text-slate-900 font-montserrat">
                        {seller.avg_hours.toFixed(1)} hrs
                      </span>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-bold font-montserrat ${
                        seller.avg_hours <= 24
                          ? 'bg-[#67A43C]/10 text-[#67A43C]'
                          : seller.avg_hours <= 48
                          ? 'bg-[#E6B43C]/10 text-[#E6B43C]'
                          : 'bg-red-50 text-red-600'
                      }`}>
                        {seller.avg_hours <= 24 ? 'Excelente' : seller.avg_hours <= 48 ? 'Bueno' : 'Mejorable'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default AverageDeliveryTime;